import { createStore } from 'vuex';
import BaseMapStylesDialogModule from '../base_map_dialog/store/modules/BaseMapStylesDialogModule';
import BaseMapDataPOIsModule from '../base_map_dialog/store/modules/BaseMapDataPOIsModule';
import BaseMapDataOverlaysModule from '../base_map_dialog/store/modules/BaseMapDataOverlaysModule';

export default createStore({
  modules: {
    mapStyles: BaseMapStylesDialogModule,
    mapDataPOIs: BaseMapDataPOIsModule,
    mapDataOverlays: BaseMapDataOverlaysModule,
  },
});
